class FixedHeader {

    #element;

    constructor() {
        const header = $('.site-header');
        this.#element = header.clone();
        this.#element.addClass('is-fixed');
        header.after(this.#element);
    }

    update() {
        const html = $('html');
        const body = $('body');
        const scrollTop = html.scrollTop();
        if (scrollTop >= 200 && !body.hasClass('has-fixed-header')) {
            body.addClass('has-fixed-header');
        } else if (scrollTop < 200 && body.hasClass('has-fixed-header')) {
            body.removeClass('has-fixed-header');
        }
        window.requestAnimationFrame(() => {
            this.update();
        });
    }
}

class PopupPayPal {

  _el = null;

  _id = null;

  constructor(selector) {
    const el = $(selector);
    if (el.length) {
      const options = el.find('[name=amount]'),
        other = el.find('#amount-other'),
        custom = el.find('[name=custom]'),
        amount = el.find('.amount'),
        extra = el.find('.extra'),
        total = el.find('.total'),
        button = el.find('.btn-checkout');
      options.on('change', () => {
        const checked = options.filter(':checked');
        let quantity = checked.val();
        custom.prop('disabled', !other.prop('checked'));
        if (quantity == 'other') {
          quantity = custom.val();
        }
        let percent = (quantity * 0.05).toFixed(2),
          cost = Number(quantity) - Number(percent);
        amount.text(cost.toFixed(2));
        extra.text(percent);
        total.text(quantity);
        button.removeClass('disabled');
      });
      custom.on('change', () => {
        let quantity = custom.val();
        let percent = (quantity * 0.05).toFixed(2),
          cost = Number(quantity) - Number(percent);
        amount.text(cost.toFixed(2));
        extra.text(percent);
        total.text(quantity);
        button.removeClass('disabled');
      });
      button.on('click', (e) => {
        const id = this._id;
        e.preventDefault();
        button.addClass('d-none');
        options.prop('disabled', true);
        options.prop('custom', true);
        el.find('.checkout').removeClass('d-none');
        window.paypal.Buttons({
          async createOrder() {
            console.log('createOrder');
            try {
              const response = await fetch(`${window.Url.apiUrl}/orders/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  cart: [
                    {
                      id: id,
                      quantity: total.text(),
                    },
                  ],
                }),
              });
              const orderData = await response.json();
              if (orderData.id) {
                return orderData.id;
              } else {
                const errorDetail = orderData?.details?.[0];
                const errorMessage = errorDetail
                  ?`${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                  : JSON.stringify(orderData);
                throw new Error(errorMessage);
              }
            } catch (error) {
              console.error(error);
            }
          },
          async onApprove(data, actions) {
            try {
              const response = await fetch(`${window.Url.apiUrl}/orders/${data.orderID}/capture`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
              });
              const orderData = await response.json();
              const errorDetail = orderData?.details?.[0];
              if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
                return actions.restart();
              } else if (errorDetail) {
                throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
                $.magnificPopup.close();
                $.magnificPopup.open({
                  items: {
                    src: '#popup-error',
                    type: 'inline'
                  }
                });
              } else if (!orderData.purchase_units) {
                throw new Error(JSON.stringify(orderData));
                $.magnificPopup.close();
                $.magnificPopup.open({
                  items: {
                    src: '#popup-error',
                    type: 'inline'
                  }
                });
              } else {
                const transaction = orderData?.purchase_units?.[0]?.payments?.captures?.[0] || orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];
                $.magnificPopup.close();
                $.magnificPopup.open({
                  items: {
                    src: '#popup-thanks',
                    type: 'inline'
                  }
                });
              }
            } catch (error) {
              console.error(error);
            }
          }
        }).render("#paypal-button-container");
      });
      this._el = el;
    }
  }

  show(id, title) {
    this._id = id;
    this._el.find('h3').text(title);
    this._el.find('.btn-checkout').removeClass('d-none').addClass('disabled');
    this._el.find('.checkout').addClass('d-none');
    this._el.find('#paypal-button-container').empty();
    this._el.find('.amount').text(0);
    this._el.find('.extra').text(0);
    this._el.find('.total').text(0);
    this._el.find('[name=amount]').prop('checked', false);
    this._el.find('[name=custom]').val(5);
    this._el.find('input').prop('disabled', false);
    $.magnificPopup.open({
      items: {
        src: this._el,
        type: 'inline'
      }
    });
  }
}

class App {

  #fixedHeader;

  #popup;

  constructor(){
    this.bindEvents();

    window.openDonationPopup = (e) => {
      let id = e.target.dataset.id,
        title = e.target.dataset.title;
      this.#popup.show(id, title);
    };
  }

  bindEvents() {
    document.addEventListener('alpine:init', () => {

      console.log('🏔️ Alpine.js initialized');

      this.#fixedHeader = new FixedHeader();
      this.#fixedHeader.update();

      this.#popup = new PopupPayPal('#popup-paypal');

      Alpine.data('utils', () => ({
        showDetails() {
          this.$el.closest('.overview').classList.add('d-none');
          document.querySelector('.details').classList.remove('d-none');
        },
        hideVideo() {
          document.querySelector('.lobster-detail').classList.remove('is-video');
          document.querySelector('.pager .page-first').classList.add('is-selected');
          document.querySelector('.pager .page-last').classList.remove('is-selected');
        },
        showVideo() {
          document.querySelector('.lobster-detail').classList.add('is-video');
          document.querySelector('.pager .page-first').classList.remove('is-selected');
          document.querySelector('.pager .page-last').classList.add('is-selected');
        }
      }));

      Alpine.data('overlay', () => ({
        overlay: null,
        init() {
          this.overlay = this.$el;
        },
        open() {
          this.overlay.classList.add('is-open');
        },
        close() {
          this.overlay.classList.remove('is-open');
        }
      }));

      Alpine.data('quantity', () => ({
        value: 1,
        increase() {
          this.value += this.value < 99 ? 1 : 0;
        },
        decrease() {
          this.value -= this.value > 1 ? 1 : 0;
        },
        update() {
          this.value = parseInt(this.$el.value);
        }
      }));

      Alpine.data('accordion', () => ({
        container: null,
        init() {
          this.container = this.$el;
        },
        toggle() {
          this.container.classList.toggle('is-open');
        }
      }));

      Alpine.data('tags', () => ({
        container: null,
        init() {
          this.container = this.$el;
          console.log(navigator.share);
          if (! navigator.share ) {
            this.$refs.share.classList.add('d-none');
          }
        },
        toggle() {
          const tag = this.$el.closest('.col-12, .col-6');
          if ( tag.classList.contains('col-12') ) {
            this.container.querySelectorAll('.col-6').forEach(col => {
              col.classList.remove('d-none');
            });
            tag.classList.remove('col-12');
            tag.classList.add('col-6');
            this.$refs.button.classList.add('disabled');
          } else {
            this.container.querySelectorAll('.col-6').forEach(col => {
              col.classList.add('d-none');
            });
            tag.classList.remove('d-none');
            tag.classList.remove('col-6');
            tag.classList.add('col-12');
            this.$refs.button.classList.remove('disabled');
          }
        },
        share() {
          try {
            const data = {
              title: "MDN",
              text: "Learn web development on MDN!",
              url: "https://developer.mozilla.org",
            };
            navigator.share(data);
          } catch(err) {
            console.log(err);
          }
        }
      }));

      Alpine.data('expander', () => ({
        container: null,
        init() {
          this.container = this.$el;
        },
        expand() {
          const anchor = this.$el;
          const articles = this.container.querySelectorAll('article');
          articles.forEach(article => {
            article.classList.remove('is-expanded');
          });
          anchor.closest('article').classList.add('is-expanded');
        }
      }));

      Alpine.data('menu', () => ({
        menu: null,
        init() {
          this.menu = document.querySelector('.menu-overlay');
        },
        open() {
          this.menu.classList.add('is-open');
        },
        close() {
          this.menu.classList.remove('is-open');
        },
      }));

      Alpine.data('oracle', () => ({
        overlay: null,
        init() {
          this.overlay = document.querySelector('.overlay-oracle');
          this.transition();
          setTimeout(() => {
            this.dismiss();
          }, 3000)
        },
        transition() {
          this.overlay.classList.add('is-open');
          this.overlay.style.opacity = 1;
          jQuery(this.overlay).animate({
            opacity: 0
          }, 1500, () => {
            this.overlay.classList.remove('is-open');
          });
        },
        dismiss() {
          document.querySelector('.wrapper-splash').classList.add('d-none');
          this.transition();
        },
        reading() {
          document.querySelector('.wrapper-question').classList.add('d-none');
          document.querySelector('.site-header').classList.add('is-fixed');
          document.querySelector('.wrapper-reading').classList.remove('d-none');
          this.transition();
        },
        showVideo() {
          document.querySelector('.lobster .box').classList.add('d-none');
          document.querySelector('.lobster .video-container').classList.remove('d-none');
          document.querySelector('.pager .page-first').classList.remove('is-selected');
          document.querySelector('.pager .page-last').classList.add('is-selected');
        },
        hideVideo() {
          document.querySelector('.lobster .box').classList.remove('d-none');
          document.querySelector('.lobster .video-container').classList.add('d-none');
          document.querySelector('.pager .page-first').classList.add('is-selected');
          document.querySelector('.pager .page-last').classList.remove('is-selected');
        }
      }));

      Alpine.data('faqs', () => ({
        container: null,
        init() {
          this.container = this.$el;
        },
        open() {
          const current = this.$el.closest('.faq');
          const faqs = this.container.querySelectorAll('.faq');
          if (current.classList.contains('is-open')) {
            current.classList.remove('is-open');
          } else {
            faqs.forEach(faq => {
              faq.classList.remove('is-open');
            });
            current.classList.add('is-open');
          }
        }
      }));

      Alpine.data('swatches', () => ({
        el: null,
        input: null,
        init() {
          this.el = this.$el;
          this.input = this.$refs.input;
        },
        select() {
          const swatch = this.$el;
          this.el.querySelectorAll('.is-selected').forEach(selected => {
            selected.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');
          this.input.value = swatch.dataset.value;
        }
      }));

      Alpine.data('cycler', () => ({
        container: null,
        pos: 0,
        init() {
          this.container = document.querySelector('.lobster-cycler .lobster');
          if (this.container) {
            this.preload();
          }
        },
        preload() {
          this.container.classList.add('is-loading');
          let index = 0;
          let pending = window.Lobsters.length;
          window.Lobsters.forEach((lobster) => {
            const img = document.createElement('img');
            const id = index;
            img.onload = () => {
              window.Lobsters[id].assets = window.Lobsters[id].assets || {};
              window.Lobsters[id].assets.image = img;
              window.Lobsters[id].loaded = true;
              pending--;
              if (pending === 0) {
                this.cycle();
                this.container.classList.remove('is-loading');
              }
            };
            window.Lobsters[index].loaded = false;
            img.src = lobster.poster.src;
            index++;
          });
        },
        cycle() {
          const image = this.container.querySelector('img');
          const anchor = this.container.querySelector('a');
          image.src = window.Lobsters[this.pos].assets.image.src;
          anchor.href = `${window.Url.siteUrl}/mutation/${this.pos + 1}`;
          this.pos++;
          if (this.pos >= window.Lobsters.length) {
            this.pos = 0;
          }
          setTimeout(() => {
            this.cycle();
          }, 50);
        }
      }));
    });
  }
}

window.App = window.App || new App();
